<template>
  <div>
    <div class="login-form">
      <div class="input-form" v-if="success">
        <p class="reset-password-successful-title">A password reset link has been sent to your email.</p>
        <p class="reset-password-successful-title">Not there? Check your spam folder or <u class="back-to-forgotten-password-button" @click.prevent="success = false">try again</u></p>
      </div>

      <div v-else>
        <p class="forgotten-password-title">Type in your email below and we’ll send you a reset password link</p>

        <div class="input-form">
          <div class="email-input-group">
            <p class="input-label">Email</p>
            <input class="input" v-model="email" />
          </div>
          <p class="invalid-label" v-show="hasInvalidEmail"><img src="@/assets/error.png" />Please fill in a valid email</p>
        </div>

        <button class="form-button" @click.prevent="resetPassword">Reset password</button>

        <div align="center">
          <back-button :backButtonText="backButtonText" @go-back="back" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import BackButton from './BackButton.vue';

export default {
  components: {
    BackButton
  },
  data(){
    return {
      email: '',
      hasInvalidEmail: false,
      success: false,
      backButtonText: 'Back to login'
    }
  },
  methods: {
    backToForgottenPassword() {
      this.success = false
    },
    async resetPassword() {
      if (this.email.length <= 0) {
        this.hasInvalidEmail = true
        return;
      }

      var response_json = await this.forgotPassword()
      if (response_json.status === "fail") {
        this.hasInvalidEmail = true
      } else {
        this.email = ''
        this.hasInvalidEmail = false
        this.success = true
      }
    },
    async forgotPassword() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({"email": this.email});
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      return await fetch(`https://oauth${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : '-stage'}.fanscore.com/users/forgotPassword?clientId=CAST`, requestOptions)
        .then(response => response.json())
        .then(data => {
          return data
        })
        .catch(error => console.log('error', error));
    },
    back() {
      this.email = ''
      this.success = false
      this.hasInvalidEmail = false
      this.$emit('back-to-login')
    }
  }
}
</script>

<style>
.forgotten-password-title {
  text-align: left;
}
.reset-password-successful-title {
  text-align: left;
}
.back-to-forgotten-password-button {
  cursor: pointer;
}
.back-to-forgotten-password-button, .back-to-forgotten-password-button:hover {
  color: white;
}
</style>